import { render, staticRenderFns } from "./TraverDetialChange.vue?vue&type=template&id=817b2330"
import script from "./TraverDetialChange.vue?vue&type=script&lang=js"
export * from "./TraverDetialChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports